import { Role } from "@context/AuthContext";
import i18n from "@lib/i18n";
import {
  CarFront,
  Info,
  Layers,
  LayoutDashboard,
  LinkIcon,
  Settings,
  User,
  Users,
} from "lucide-react";

export const ENDPOINTS = {
  // User
  USER_LOGIN: "/loginToken",
  USER_LINK_ACCOUNT: "/verifyToken",
  BASE_DRIVER: "/drivers",
  BASE_DRIVER_GROUPS: "/driver_groups",
  BASE_UNITS: "/units",
  BASE_UNIT_GROUPS: "/unit_groups",
  BASE_BINDING: "/bindings",

  // Admin
  ADMIN_LOGIN: "/admin/login",
  BASE_ADMIN_USERS: "/admin/users",
};

export const enum BindingTypes {
  Onetime = "one_time",
  Expiring = "expiring",
  Recurring = "recurring",
}

export const BindingTypeOptions = [
  { value: BindingTypes.Onetime, label: "one_time" },
  { value: BindingTypes.Expiring, label: "expiring" },
  { value: BindingTypes.Recurring, label: "recurring" },
];

export const weekdays = [
  i18n.t("weekdays.monday"),
  i18n.t("weekdays.tuesday"),
  i18n.t("weekdays.wednesday"),
  i18n.t("weekdays.thursday"),
  i18n.t("weekdays.friday"),
  i18n.t("weekdays.saturday"),
  i18n.t("weekdays.sunday"),
];

export const MENU_ITEMS = [
  {
    title: i18n.t("general.dashboard"),
    href: "/user/dashboard",
    icon: LayoutDashboard,
    roles: [Role.User],
  },
  {
    title: i18n.t("general.driversManagement"),
    href: "/user/drivers-management",
    icon: User,
    roles: [Role.User],
  },
  {
    title: i18n.t("general.driverGroupsManagement"),
    href: "/user/driver-groups-management",
    icon: Users,
    roles: [Role.User],
  },
  {
    title: i18n.t("general.unitsManagement"),
    href: "/user/units-management",
    icon: CarFront,
    roles: [Role.User],
  },

  {
    title: i18n.t("general.unitGroupsManagement"),
    href: "/user/unit-groups-management",
    icon: Layers,
    roles: [Role.User],
  },
  {
    title: i18n.t("general.bindingsManagement"),
    href: "/user/bindings-management",
    icon: LinkIcon,
    roles: [Role.User],
  },
  {
    title: i18n.t("general.dashboard"),
    href: "/admin/dashboard",
    icon: LayoutDashboard,
    roles: [Role.Admin],
  },
  {
    title: "Users Management",
    href: "/admin/users",
    icon: Users,
    roles: [Role.Admin],
  },
];

export const BOTTOM_MENU_ITEMS = [
  {
    title: i18n.t("general.helpCenter"),
    href: "/admin/help-center",
    icon: Info,
    roles: [Role.Admin],
    hasDivider: true,
  },
  {
    title: i18n.t("general.helpCenter"),
    href: "/help",
    icon: Info,
    roles: [Role.User],
    hasDivider: true,
  },
  {
    title: i18n.t("general.settings"),
    href: "/settings",
    icon: Settings,
    roles: [Role.Admin, Role.User],
  },
];
